import script from "./CertificationViewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationViewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationViewComponent.vue?vue&type=style&index=0&id=1977d84c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1977d84c"]])

export default __exports__